
import './App.css';

import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Footer from './components/layouts/Footer';
import Header from './components/layouts/Header';
import MobileBottomNav from './components/layouts/MobileBottomNav';

import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './components/user/Login';
import store from './store';
import { useEffect } from 'react';
import { loadUser } from './actions/userActions';
import ProtectedRoute from './components/routes/ProtectedRoute';

import Dashboard from './components/Dashboard/Dashboard';
import NewPatient from './components/patients/NewPatient';
import PatientList from './components/patients/PatientList';
import UpdatePatient from './components/patients/UpdatePatient';
import PatientDetail from './components/patients/PatientDetail';
import AllBills from './components/billing/AllBills';
import NewBill from './components/billing/NewBill';
import EditBill from './components/billing/EditBill';
import PublicInvoice from './components/billing/PublicInvoice';
import PublicDiet from './components/diet/PublicDiet';
import StaffList from './components/staff/StaffList';
import NewStaff from './components/staff/NewStaff';
import UpdateStaff from './components/staff/UpdateStaff';
import Attendance from './components/attendance/Attendance';
import Accounts from './components/accounts/Accounts';
import TreatmentList from './components/treatments/TreatmentList';
import DesignationList from './components/designation/DesignationList';
import CategoryList from './components/category/CategoryList';
import TrashBin from './components/admin/TrashBin';
import UserList from './components/user/UserList';
import RegisterUser from './components/user/RegisterUser';
import CommonDietList from './components/diet/CommonDietList';
import HospitalDetails from './components/hospital/HospitalDetails';



import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Redirect from './redirect/Redirect';

function App() {

  useEffect(() => {
    store.dispatch(loadUser)

  }, [])
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Router>
        <div className="App">
          <HelmetProvider>
            <Header />
            <div className='container container-fluid'>
              <ToastContainer theme='dark' position='bottom-center' />

            </div>
            <Routes>

              <Route path='/' element={<Redirect/>} />

              <Route path='/glogin' element={<Login />} />
              <Route path='/invoice/:id' element={<PublicInvoice />} />
              <Route path='/diet/view/:tokenOrId' element={<PublicDiet />} />
              <Route path='/diet/:tokenOrId' element={<PublicDiet />} />
              <Route path='/dashboard' element={<ProtectedRoute> <Dashboard /> </ProtectedRoute>} />
              <Route path='/admin/newpatient' element={<ProtectedRoute isStrictAdmin={true} allowDoctor={true}> <NewPatient /> </ProtectedRoute>} />
              <Route path='/patients' element={<ProtectedRoute> <PatientList /> </ProtectedRoute>} />
              <Route path='/admin/patients' element={<Navigate to="/patients" replace />} />
              <Route path='/admin/diets' element={<ProtectedRoute><CommonDietList /></ProtectedRoute>} />
              <Route path='/diets' element={<Navigate to="/admin/diets" replace />} />
              <Route path='/admin/hospital' element={<ProtectedRoute><HospitalDetails /></ProtectedRoute>} />
              <Route path='/hospital' element={<Navigate to="/admin/hospital" replace />} />
              <Route path='/admin/patient/:id' element={<ProtectedRoute isStrictAdmin={true}><UpdatePatient /></ProtectedRoute>} />
              <Route path='/patient/:id' element={<ProtectedRoute><PatientDetail /></ProtectedRoute>} />
              <Route path='/admin/billing' element={<ProtectedRoute isAdmin={true}><AllBills /></ProtectedRoute>} />
              <Route path='/admin/billing/new' element={<ProtectedRoute isStrictAdmin={true}><NewBill /></ProtectedRoute>} />
              <Route path='/admin/billing/:id/edit' element={<ProtectedRoute isStrictAdmin={true}><EditBill /></ProtectedRoute>} />
              <Route path='/admin/staff' element={<ProtectedRoute isAdmin={true}><StaffList /></ProtectedRoute>} />
              <Route path='/admin/staff/new' element={<ProtectedRoute isStrictAdmin={true}><NewStaff /></ProtectedRoute>} />
              <Route path='/admin/staff/:id/edit' element={<ProtectedRoute isStrictAdmin={true}><UpdateStaff /></ProtectedRoute>} />
              <Route path='/admin/attendance' element={<ProtectedRoute isAdmin={true}><Attendance /></ProtectedRoute>} />
              <Route path='/admin/accounts' element={<ProtectedRoute isAdmin={true}><Accounts /></ProtectedRoute>} />
              <Route path='/admin/categories' element={<ProtectedRoute isAdmin={true}><CategoryList /></ProtectedRoute>} />
              <Route path='/admin/treatments' element={<ProtectedRoute isAdmin={true}><TreatmentList /></ProtectedRoute>} />
              <Route path='/admin/designations' element={<ProtectedRoute isAdmin={true}><DesignationList /></ProtectedRoute>} />
              <Route path='/admin/trash' element={<ProtectedRoute isStrictAdmin={true}><TrashBin /></ProtectedRoute>} />
              <Route path='/admin/users' element={<ProtectedRoute isAdmin={true}><UserList /></ProtectedRoute>} />
              <Route path='/admin/users/new' element={<ProtectedRoute isMasterOnly={true}><RegisterUser /></ProtectedRoute>} />
              <Route path='/admin/user/new' element={<ProtectedRoute isMasterOnly={true}><RegisterUser /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" />} />

            </Routes>
            <Footer />
            <MobileBottomNav />
          </HelmetProvider>
        </div>
      </Router>
    </LocalizationProvider>
  );
}

export default App;
